// Profil-Nachbau F-25 Entwurf C (output/profil-team-20261014/cockpit-grafiken-20261019/SCHNITTSTELLEN-C.md 2.1, 3.2; Server PF-GC-server-1,
// backend/src/administration/cockpit/ziele.ts): Typen und Wege der Ziele des KI-Cockpits. Je Firma Recherchen je 30 Tage und Antworten
// mit Quelle (Prozent), für die Plattform aktive Firmen, Kostendeckung und Antworten mit Quelle (Prozent). Nie je Person. Ohne gesetztes
// Ziel { wert: null, revision: 0 }. Setzen: Firma Besitzer und organization.write (nie in einer Sicht), Plattform platform.settings.write;
// eine veraltete Revision gibt 409 STALE_ZIEL.
import { adminApi } from '../api';
import { PLATTFORM_WEG } from './cockpitApi';

export type ZielArtFirma = 'RECHERCHEN_30_TAGE' | 'ANTWORTEN_MIT_QUELLE';
export type ZielArtPlattform = 'AKTIVE_FIRMEN' | 'KOSTENDECKUNG' | 'ANTWORTEN_MIT_QUELLE';
export type Ziel = { wert: number | null; revision: number };
export type FirmaZiele = { ziele: Record<ZielArtFirma, Ziel>; darfSetzen: boolean };
export type PlattformZiele = { ziele: Record<ZielArtPlattform, Ziel>; darfSetzen: boolean };
export type ZielEingabe<A extends string> = { art: A; wert: number | null; expectedRevision: number };

/** Dieselben Grenzen wie am Server und in der Datenbank (ziele.ts ZIEL_GRENZEN, Migration 20261019130000_ki_cockpit_ziele). */
export const ZIEL_GRENZEN = { RECHERCHEN_30_TAGE: [1, 9999], ANTWORTEN_MIT_QUELLE: [1, 100], AKTIVE_FIRMEN: [1, 100], KOSTENDECKUNG: [1, 1000] } as const;
export const ZIEL_VERALTET = 'STALE_ZIEL';

export const firmaZieleAdresse = (firmaId: string) => `/organizations/${encodeURIComponent(firmaId)}/ki-cockpit/ziele`;
export const firmaZielSetzen = (firmaId: string, eingabe: ZielEingabe<ZielArtFirma>) => adminApi.put<FirmaZiele>(firmaZieleAdresse(firmaId), eingabe);
export const PLATTFORM_ZIELE_WEG = `${PLATTFORM_WEG}/ziele`;
export const plattformZielSetzen = (eingabe: ZielEingabe<ZielArtPlattform>) => adminApi.put<PlattformZiele>(PLATTFORM_ZIELE_WEG, eingabe);
